import {
  ATLAS_AGENT_NAME,
  ATLAS_AGENT_PRINCIPAL_ID,
} from '@core/constant/atlasAgent';
import { ATLAS_NEW_PRINCIPAL_ID } from '@core/constant/atlasNew';
import {
  CODEX_BOT_NAME,
  CODEX_BOT_PRINCIPAL_ID,
} from '@core/constant/codexAgent';
import {
  CURSOR_BOT_NAME,
  CURSOR_BOT_PRINCIPAL_ID,
} from '@core/constant/cursorAgent';
import type { IUser } from '@core/user/types';

// Re-export the shared Atlas identity under the names used in this package.
export {
  ATLAS_AGENT_BOT_ID as ATLAS_AI_BOT_ID,
  ATLAS_AGENT_HANDLE as ATLAS_AI_HANDLE,
  ATLAS_AGENT_NAME as ATLAS_AI_NAME,
  ATLAS_AGENT_PRINCIPAL_ID as ATLAS_AI_PRINCIPAL_ID,
  isAtlasAgentId as isAtlasAiId,
} from '@core/constant/atlasAgent';
export { isAtlasCoderId } from '@core/constant/atlasCoder';
export { isAtlasNewId } from '@core/constant/atlasNew';

/**
 * The single synthetic [`IUser`] entry for Atlas in the channel `@`-mention
 * typeahead. The mention rides the existing user-mention machinery and is
 * re-tagged as a bot mention at send time (see `authoredMentions`). `email` is set
 * to the display name so the typeahead shows just "Atlas". The id uses the
 * canonical `bot|<uuid>` principal form so persisted mention content matches
 * bot sender/participant ids.
 *
 * Which Atlas answers is the rollout's business, not the mentioning user's:
 * under chat-v3 `@atlas` opens an agent session, otherwise it gets the classic
 * in-channel reply. Only ever one entry, named "Atlas" either way.
 */
export function atlasMentionUser(agentSessions: boolean): IUser {
  return {
    id: agentSessions ? ATLAS_NEW_PRINCIPAL_ID : ATLAS_AGENT_PRINCIPAL_ID,
    name: ATLAS_AGENT_NAME,
    email: ATLAS_AGENT_NAME,
  };
}

/**
 * The Cursor bot as a synthetic mention user, exactly like
 * [`atlasMentionUser`]. Mentioning it opens an agent session served by
 * a Cursor cloud agent.
 */
export function cursorMentionUser(): IUser {
  return {
    id: CURSOR_BOT_PRINCIPAL_ID,
    name: CURSOR_BOT_NAME,
    email: CURSOR_BOT_NAME,
  };
}

/** Codex as a bot mention, using the canonical principal identifier. */
export function codexMentionUser(): IUser {
  return {
    id: CODEX_BOT_PRINCIPAL_ID,
    name: CODEX_BOT_NAME,
    email: CODEX_BOT_NAME,
  };
}
